import Select from "react-select";
import { CSVLink } from "react-csv";
import { useCompanyStockDetailDashboard } from "./hooks";
import { useComponent, useElement, useLocale } from "../../../hooks";

export const CompanyStockDetailDashboard = () => {
  const { t } = useLocale();
  const DatePicker = useElement("DatePicker");
  const Input = useElement("Input");
  const Table = useComponent("Table");
  const exportedFileName =
    "exported_daily_stock_" +
    new Date().getDate() +
    "_" +
    new Date().getMonth() +
    "_" +
    new Date().getFullYear() +
    ".csv";
  const {
    user,
    exportedData,
    branches,
    activeBranches,
    selectCompany,
    setfromFilterDate,
    fromFilterDate,
    settoFilterDate,
    toFilterDate,
    searchPostKey,
    searchPost,
    tableContent,
    activeShownTotal,
  } = useCompanyStockDetailDashboard();

  return (
    <>
      <div className="right-side-profile-content">
        <div className="header-title-box">
          <div className="overflow-visible">
            <div className="flex">
              <h1 className="title">
                Daily Stock Detail Report
                <p className="company-title">{user.name}</p>
              </h1>
              <span className="mlauto">
                <CSVLink
                  data={exportedData}
                  filename={exportedFileName}
                  className="btn btn-primary btn-small export-btn"
                  target="_blank"
                >
                  {t("export")}
                </CSVLink>
              </span>
            </div>
            {/* <div className="ml20 mt10 select-filter">
                        <Select
                            value={activeDateFilter}
                            defaultValue={activeDateFilter}
                            onChange={activeDateFilter => {
                                setactiveDateFilter(activeDateFilter)
                                getDashboardData(activeDateFilter, activeBranches)
                            }}
                            options={activeDateFilter}
                        />
                    </div> */}
          </div>
          {
            // activeDateFilter?.value === 'specificDuration' &&
            <div className="select-filter">
              <ul className="mb20 ml-20">
                {["company", "representative"].includes(user.role) &&
                  branches.length > 0 && (
                    <li>
                      <label>Select Branches</label>
                      <Select
                        isClearable
                        closeMenuOnSelect={false}
                        placeholder={t("selectCompany")}
                        defaultValue={activeBranches}
                        onChange={selectCompany}
                        options={branches}
                        isMulti
                      />
                    </li>
                  )}
                <li>
                  <label>{t("fromDate")}</label>
                  <DatePicker
                    showMonthDropdown
                    showYearDropdown
                    dateFormat="MMMM d, yyyy"
                    onChange={(fromFilterDate) =>
                      setfromFilterDate(fromFilterDate)
                    }
                    className="date-picker"
                    selected={fromFilterDate}
                    maxDate={new Date()}
                    placeholderText={t("placeholder.fromDate")}
                  />
                </li>
                <li>
                  <label>{t("toDate")}</label>
                  <DatePicker
                    showMonthDropdown
                    showYearDropdown
                    dateFormat="MMMM d, yyyy"
                    onChange={(toFilterDate) => settoFilterDate(toFilterDate)}
                    className="date-picker"
                    selected={toFilterDate}
                    maxDate={new Date()}
                    placeholderText={t("placeholder.toDate")}
                  />
                </li>
                <li className="filter-box flex column">
                  <label>{t("registrationNo")}</label>
                  <Input
                    required
                    name="searchPostKey"
                    value={searchPostKey || ""}
                    placeholder={t("placeholder.search")}
                    onChange={searchPost}
                    className="form-control"
                  />
                </li>
              </ul>
            </div>
          }
        </div>
        <Table data={tableContent} pageSize={activeShownTotal} />
      </div>
    </>
  );
};
